var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckCircle = function SvgCheckCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0a18 18 0 1 0 18 18A18.053 18.053 0 0 0 18 0m-3.7 27.6-9.22-9.228 2.588-2.588 6.646 6.646L28.341 8.403l2.584 2.587z"
  })));
};
export default SvgCheckCircle;